var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('TopNav'),_c('router-view',{staticClass:"router_view"}),_c('AppFooter',{directives:[{name:"show",rawName:"v-show",value:(_vm.footerShow),expression:"footerShow"}],staticClass:"mt30 footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }